const ROUTE_STOP_FACT_SCHEMA_VERSION = 'indoor-route-stop-fact-source/v1';

function createRouteStopId(cryptoApi = globalThis.crypto) {
  if (!cryptoApi || typeof cryptoApi.getRandomValues !== 'function') {
    throw new Error('Web Crypto getRandomValues indisponivel para criar routeStopId');
  }

  const bytes = new Uint8Array(16);
  cryptoApi.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0'));
  const uuid = [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-');
  return `route-stop-${uuid}`;
}

function createRouteStop({ position, sectionName = '', sectionId = '' }, cryptoApi) {
  return {
    routeStopId: createRouteStopId(cryptoApi),
    posicao: { x: position.x, y: position.y },
    direita: '',
    esquerda: '',
    frente: '',
    secao: sectionName,
    secaoId: sectionId,
  };
}

function applyRouteStopTypedEdit(stop, draft = {}) {
  const next = {
    ...stop,
    direita: draft.direita,
    esquerda: draft.esquerda,
    frente: draft.frente,
  };

  if (draft.relation && draft.target) {
    next.schemaVersion = ROUTE_STOP_FACT_SCHEMA_VERSION;
    next.relation = draft.relation;
    next.target = draft.target;
  } else {
    delete next.schemaVersion;
    delete next.relation;
    delete next.target;
  }

  return next;
}

export {
  ROUTE_STOP_FACT_SCHEMA_VERSION,
  applyRouteStopTypedEdit,
  createRouteStop,
  createRouteStopId,
};
